// React imports.
import React, { Component } from "react";

// App imports.


const IntroPage2 = ({ state }) => (
  <div >
    <h2>LIHEAP Targeting Indices</h2>
    <br />
    <p>The <a target="_blank" href="https://www.acf.hhs.gov/ocs/law-regulation/liheap-statute-and-regulations">Federal LIHEAP Statute</a> requires that &ldquo;<em><span>the highest level of assistance will be furnished to those households which have the lowest incomes and the highest energy costs or needs in relation to income, taking into account family size&hellip;&rdquo; </span></em><span>(Section 2605 (5)).</span></p>
    <p>In order to ensure that grant recipients are in compliance with this requirement, OCS developed two Performance Measures to measure and quantify <strong><u>Energy Burden Targeting</u></strong>:</p>
    <ol>
      <li>The Benefit Targeting Index; and </li>
      <li>The Burden Reduction Targeting Index</li>
    </ol>
    <p>Each of these indices is explained in more detail on the following screens. But for now, you should note that in order to produce them, OCS requires all grant recipients to report the Average Annual Household Income, Average Annual Total Energy Bill, and Average Annual Total LIHEAP Benefit for <em>both </em><strong>All LIHEAP Households</strong> and <strong>High Burden Households</strong> each year.</p>
    <p>In this context, the following definitions apply:</p>
    <ul>
      <li><strong>Household Energy Burden:</strong> the percentage of gross household income spent on energy costs.<br /><br />
      </li>
      <li><strong>All LIHEAP Households: </strong>all of the LIHEAP recipient households for whom the grant recipient collected complete Performance Measures data.
        <br /><br />
      </li>
      <li><strong><span>High Burden Households: </span></strong><span>among the LIHEAP recipient households for whom the grant recipient collected complete Performance Measures data, those with energy burdens in the top 25% of the distribution.&nbsp;</span>
      </li>
    </ul>
    <p>Please click <em>Next </em>to continue. </p>
  </div>
);

export default IntroPage2;
